module.exports = __webpack_public_path__ + "img/cmed-logo.054fb2e5.png";